import React, { useEffect } from 'react';

import { Form } from 'antd';
import styled from 'styled-components';

import Button from 'components/lib/Button';
import Input from 'components/lib/Input';
import { SimpleListEntryModal } from 'components/lib/SimpleListModal';
import {
  SimpleListEntryFormContainer,
  SimpleListFieldGroup,
  SimpleListFieldInputContainer,
  SimpleListFieldLabel,
  SimpleListModalFooter,
} from 'components/lib/SimpleListModalComponents';

import { ShopRequestShopperEmailType } from '../../types';

const EntryFormContainer = styled(SimpleListEntryFormContainer)`
  width: 420px;
`;

const FieldLabel = styled(SimpleListFieldLabel)`
  width: 68px;
  flex-basis: 68px;
  white-space: nowrap;
`;

const FieldInputContainer = styled(SimpleListFieldInputContainer)`
  min-width: 0;

  .ant-input {
    width: 100%;
  }
`;

const EntryModalDescription = styled.div`
  margin-bottom: 24px;
  color: var(--text-secondary);
  font-size: 14px;
`;

type Props = {
  open: boolean;
  item?: ShopRequestShopperEmailType;
  isUpdating: boolean;
  onCancel: () => void;
  onSubmit: (values: ShopRequestShopperEmailType) => Promise<void>;
};

const ManageShopRequestShopperEmailsEntryModal = ({ open, item, isUpdating, onCancel, onSubmit }: Props) => {
  const [entryForm] = Form.useForm<ShopRequestShopperEmailType>();

  useEffect(() => {
    if (!open) {
      entryForm.resetFields();
      return;
    }

    entryForm.setFieldsValue({ label: item?.label ?? '' });
  }, [entryForm, item?.label, open]);

  return (
    <SimpleListEntryModal open={open} onCancel={onCancel} footer={null} title="Edit Label" destroyOnClose>
      <EntryModalDescription>Update the label used for this shopper contact.</EntryModalDescription>
      <Form<ShopRequestShopperEmailType> form={entryForm} onFinish={onSubmit} layout="vertical">
        <EntryFormContainer>
          <SimpleListFieldGroup>
            <FieldLabel>Label</FieldLabel>
            <FieldInputContainer>
              <Form.Item name="label">
                <Input placeholder="Optional label for this shop request" />
              </Form.Item>
            </FieldInputContainer>
          </SimpleListFieldGroup>
        </EntryFormContainer>

        <SimpleListModalFooter>
          <Button onClick={onCancel}>Cancel</Button>
          <Button type="primary" htmlType="submit" loading={isUpdating}>
            Save
          </Button>
        </SimpleListModalFooter>
      </Form>
    </SimpleListEntryModal>
  );
};

export default ManageShopRequestShopperEmailsEntryModal;
